import { atom } from 'jotai';
import moment from 'moment';

const intervalAtom = atom<{ from: string; to: string }>({
  from: moment().subtract(7, 'd').format('YYYY-MM-DD HH:mm:ss'),
  to: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
});

export default intervalAtom;
